var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container--aliased-request"},[_c('ProgressContainer',{attrs:{"is-pending":_vm.isAnyAliasedRequestPending(_vm.requestAlias)}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }